(function () {
  const sections = document.querySelectorAll('.koffi-hero[data-animate="true"]');
  if (!sections.length) return;

  const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('koffi-hero--in');
        io.unobserve(e.target);
      });
    },
    { threshold: 0.18 }
  );

  sections.forEach((s) => io.observe(s));
})();
